import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { DEFAULT_LANGUAGE, LANGUAGES, NAMESPACE, DEFAULT_NS } from "./languages";
import { loadNamespace } from "./resources";

const STORAGE_KEY = "app_language";

export async function initI18n() {
  if (i18n.isInitialized) return i18n;

  // preload минимально common для default языка, чтобы не было "мерцания ключей"
  const auth = await loadNamespace(DEFAULT_LANGUAGE, "auth");
  const menu = await loadNamespace(DEFAULT_LANGUAGE, "menu");
  const validation = await loadNamespace(DEFAULT_LANGUAGE, "validation");
  const common = await loadNamespace(DEFAULT_LANGUAGE, "common");

  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: DEFAULT_LANGUAGE,
      supportedLngs: LANGUAGES,
      ns: NAMESPACE,
      defaultNS: DEFAULT_NS,
      resources: {
        [DEFAULT_LANGUAGE]: { common, auth, menu, validation }
      },
      detection: {
        order: ["localStorage", "navigator"],
        lookupLocalStorage: STORAGE_KEY,
        caches: ["localStorage"],
        checkWhitelist: true
      },
      interpolation: { escapeValue: false },
      react: { useSuspense: true }
    });

  return i18n;
}

export async function ensureNamespace(ns) {
  const lng = i18n.resolvedLanguage || DEFAULT_LANGUAGE;

  if (!i18n.hasResourceBundle(lng, ns)) {
    const dict = await loadNamespace(lng, ns);
    i18n.addResourceBundle(lng, ns, dict, true, true);
  }
}

export async function changeLanguage(lng) {
  // подгружаем common заранее
  if (!i18n.hasResourceBundle(lng, "common")) {
    const dict = await loadNamespace(lng, "common");
    i18n.addResourceBundle(lng, "common", dict, true, true);
  }
  await i18n.changeLanguage(lng);
}

export default i18n;
